import { render } from "./AncillaryView.vue?vue&type=template&id=c834b55e"
import script from "./AncillaryView.vue?vue&type=script&lang=js"
export * from "./AncillaryView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__